export const KYC_SUBMITTED_EVENTS = {
  VIEW_KYC_SUBMITTED_PAGE: 'view_kyc_submitted',
  SELECT_KYC_SURVEY: 'select_kyc_survey',
  VIEW_KYC_IDENTITY_VALIDATION: 'view_kyc_identity_validation',
  VIEW_KYC_SUBMITTED_FIRST_MESSAGE: 'view_kyc_submitted_first_message',
  VIEW_KYC_SUBMITTED_SECOND_MESSAGE: 'view_kyc_submitted_second_message',
} as const;
